import Delete from "@mui/icons-material/Delete";
import Grid2 from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { getFieldPath } from "../../Common/SchemaUtils";

const MeasureFormFields: React.FC<{
  extractionId: string;
  extractionPath?: string;
  label?: string;
  remove?: Function;
}> = ({ extractionId, extractionPath, remove }) => {
  const { control } = useFormContext();

  const valuePath = `extraction.${getFieldPath([
    extractionId,
    "value",
    extractionPath,
  ])}.value`;
  const unitPath = `extraction.${getFieldPath([
    extractionId,
    "value",
    extractionPath,
  ])}.unit`;

  return (
    <Grid2
      container
      spacing={1}
      key={getFieldPath([extractionId, extractionPath])}
      sx={{ alignItems: "flex-end" }}
    >
      <Grid2 size={remove !== undefined ? 11 : 12} sx={{ display: "flex" }}>
        <Controller
          name={valuePath}
          control={control}
          render={({ field: valueField, fieldState: { error } }) => (
            <TextField
              {...valueField}
              size="small"
              label="Valeur"
              type="number"
              fullWidth
              variant="outlined"
              error={!!error}
              helperText={error?.message}
              onChange={(e) => {
                const numericValue = Number(e.target.value);
                valueField.onChange(
                  isNaN(numericValue) ? e.target.value : numericValue
                );
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end" sx={{ mr: -1 }}>
                    <Controller
                      name={unitPath}
                      control={control}
                      render={({ field: unitField }) => (
                        <TextField
                          {...unitField}
                          size="small"
                          variant="standard"
                          placeholder="Unité"
                          sx={{
                            "& .MuiInput-underline:before": {
                              borderBottom: "none",
                            },
                            "& .MuiInput-underline:hover:not(.Mui-disabled):before":
                              { borderBottom: "none" },
                            "& .MuiInput-underline:after": {
                              borderBottom: "none",
                            },
                            borderTopLeftRadius: 0,
                            borderBottomLeftRadius: 0,
                            borderLeft: "1px solid #e0e0e0",
                            marginLeft: 1,
                          }}
                          value={unitField.value || ""}
                          slotProps={{
                            htmlInput: { style: { textAlign: "center" } },
                          }}
                          onChange={(e) => unitField.onChange(e.target.value)}
                        />
                      )}
                    />
                  </InputAdornment>
                ),
              }}
            />
          )}
        />
      </Grid2>

      {remove !== undefined && (
        <Grid2 size={1} sx={{ textAlign: "center", pb: 0.5 }}>
          <IconButton
            onClick={() => {
              remove && remove();
            }}
            className="rounded-full"
            size="small"
          >
            <Delete color="error" />
          </IconButton>
        </Grid2>
      )}
    </Grid2>
  );
};

export default MeasureFormFields;
